import { template as template_de3f5d9c3e8249398f45b5ee1ec794c3 } from "@ember/template-compiler";
import { buildSpecialtyFacetOptions } from 'client-portal/utils/clinicianSearch/specialty-facet-options';
import { facetOptionDisabled } from 'client-portal/utils/clinicianSearch/facet-catalog';
import { fn } from '@ember/helper';
import { parseTrimmedString } from 'client-portal/utils/clinicianSearch/comma-query-param';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import Component from '@glimmer/component';
import RequestClinicianSearchFiltersFilterRadioLine from '../filters/filter-radio-line';
import RequestClinicianSearchFiltersPanel from '../filters/panel';
import styles from './specialty.module.scss';
import t from 'ember-intl/helpers/t';
const RADIO_NAME = 'clinician-search-specialty-filter';
export default class RequestClinicianSearchFacetFiltersSpecialty extends Component {
    @service
    intl;
    @service
    clinicianSearch;
    radioName = RADIO_NAME;
    @tracked
    options = [];
    @tracked
    loadFailed = false;
    @tracked
    isLoadingOptions = true;
    get selectedSpecialty() {
        return parseTrimmedString(this.clinicianSearch.query.specialty);
    }
    get panelLoading() {
        return this.isLoadingOptions || this.clinicianSearch.sendAll.isLoading;
    }
    get specialtyLoadingAriaLabel() {
        if (this.clinicianSearch.sendAll.isLoading) {
            return this.intl.t('booking.clinicianSearch.filterDetail.filterOptionsLoading');
        }
        return this.intl.t('booking.clinicianSearch.filterDetail.specialtyOptionsLoading');
    }
    refreshOptions = ()=>{
        this.loadFailed = false;
        this.isLoadingOptions = true;
        try {
            let routeParams = {
                ...this.clinicianSearch.query.toRouteParams(),
                specialty: null
            };
            let meta = this.clinicianSearch.sendAll.buildFacetsMeta(routeParams);
            this.options = buildSpecialtyFacetOptions(this.clinicianSearch.sendAll.records, meta?.facets?.specialties ?? []);
        } catch  {
            this.loadFailed = true;
            this.options = [];
        } finally{
            this.isLoadingOptions = false;
        }
    };
    isOptionSelected = (opt)=>this.selectedSpecialty.toLowerCase() === String(opt.key ?? '').toLowerCase();
    optionDisabled = (opt)=>facetOptionDisabled(opt.docCount, this.isOptionSelected(opt));
    optionId = (opt)=>String(opt.key ?? '').trim().toLowerCase().replace(/\s+/g, '-');
    specialtyOptionRowTitle = (opt)=>{
        if (!this.optionDisabled(opt)) {
            return '';
        }
        return this.intl.t('booking.clinicianSearch.filterDetail.disabledFilterOption');
    };
    selectSpecialty = (opt, event)=>{
        if (!event.target.checked || !opt.key) {
            return;
        }
        this.clinicianSearch.query.applyFacetFilter('specialty', opt.key);
        this.clinicianSearch.mobile.backFromDetail();
    };
    static{
        template_de3f5d9c3e8249398f45b5ee1ec794c3(`
    <RequestClinicianSearchFiltersPanel
      @hideApply={{true}}
      @class={{styles.component}}
      @facetKey="specialty"
      @isLoading={{this.panelLoading}}
      @loadingAriaLabel={{this.specialtyLoadingAriaLabel}}
      @onLoad={{this.refreshOptions}}
      data-test-clinician-search-filter-specialty-options
    >
      <p class="filter-section-title" id="clinician-search-specialty-filter-title">{{t
          "booking.clinicianSearch.filterDetail.specialtyFilterPanelTitle"
        }}</p>
      {{#if this.loadFailed}}
        <p class="error" data-test-clinician-search-filter-specialty-options-error>
          {{t "booking.clinicianSearch.filterDetail.specialtyLoadError"}}
        </p>
      {{/if}}
      <div class="body" role="group" aria-labelledby="clinician-search-specialty-filter-title">
        <ul class="filter-checkbox-list" role="list">
          {{#each this.options as |opt|}}
            <RequestClinicianSearchFiltersFilterRadioLine
              @kind="specialty"
              @optionId={{this.optionId opt}}
              @docCount={{opt.docCount}}
              @name={{this.radioName}}
              @value={{opt.key}}
              @checked={{this.isOptionSelected opt}}
              @disabled={{this.optionDisabled opt}}
              @title={{this.specialtyOptionRowTitle opt}}
              @onChange={{fn this.selectSpecialty opt}}
            >
              {{opt.label}}
            </RequestClinicianSearchFiltersFilterRadioLine>
          {{/each}}
        </ul>
      </div>
    </RequestClinicianSearchFiltersPanel>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
